import React, { useEffect, useState } from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { useTranslation } from 'react-i18next';
import "react-circular-progressbar/dist/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import { addResultatsCategoria } from '../../../actions/configFormularioAction';
import { ResultatsCategoria } from './ResultatsCategoria';
import { useNavigate } from 'react-router-dom';

// ─── Paleta de categorías ─────────────────────────────────────────────────────
const CAT_CONFIG = [
  { color: 'var(--color-1)', bg: 'var(--color-1-50)' },
  { color: 'var(--color-2)', bg: 'var(--color-2-50)' },
  { color: 'var(--color-3)', bg: 'var(--color-3-50)' },
  { color: 'var(--color-4)', bg: 'var(--color-4-50)' },
  { color: 'var(--color-5)', bg: 'var(--color-5-50)' },
  { color: 'var(--color-6)', bg: 'var(--color-6-50)' },
  { color: 'var(--color-7)', bg: 'var(--color-7-50)' },
  { color: 'var(--color-8)', bg: 'var(--color-8-50)' },
  { color: 'var(--color-9)', bg: 'var(--color-9-50)' },
];

// ─── Color semáforo ───────────────────────────────────────────────────────────
const getScoreColor = (val) => {
  const n = parseFloat(val);
  if (n >= 70) return 'var(--color-success)';
  if (n >= 40) return 'var(--color-warning)';
  return 'var(--color-danger)';
};

// ─── Tarjeta de categoría ─────────────────────────────────────────────────────
function CatCard({ label, value, catColor, onClick }) {
  const n = parseFloat(value);
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="res-cat-card"
      style={{
        boxShadow: hovered ? '0 8px 30px rgba(0,0,0,0.12)' : '0 1px 4px rgba(0,0,0,0.06)',
        transform: hovered ? 'translateY(-3px)' : 'none',
      }}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="res-cat-stripe" style={{ backgroundColor: catColor }} />
      <div className="res-cat-body">
        <div className="res-cat-circle">
          <CircularProgressbar
            value={isNaN(n) ? 0 : n}
            text={isNaN(n) ? '—' : `${value}%`}
            background
            backgroundPadding={6}
            styles={buildStyles({
              backgroundColor: catColor,
              textColor: '#fff',
              textSize: '20px',
              pathColor: '#fff',
              trailColor: 'transparent',
            })}
          />
        </div>
        <h5 className="res-cat-name">{label}</h5>
        <p className="res-cat-hint">Ver detalle →</p>
      </div>
    </div>
  );
}

// ─── Tarjeta global ───────────────────────────────────────────────────────────
function GlobalCard({ value }) {
  const n = parseFloat(value);
  return (
    <div className="res-global-card">
      <div className="res-cat-stripe" style={{ backgroundColor: '#6b6a6f' }} />
      <div className="res-cat-body">
        <div className="res-cat-circle">
          <CircularProgressbar
            value={isNaN(n) ? 0 : n}
            text={isNaN(n) ? '—' : `${value}%`}
            background
            backgroundPadding={6}
            styles={buildStyles({
              backgroundColor: '#6b6a6f',
              textColor: '#fff',
              textSize: '20px',
              pathColor: '#fff',
              trailColor: 'transparent',
            })}
          />
        </div>
        <h5 className="res-cat-name">Puntuación Global</h5>
        <p className="res-cat-hint">resultado total</p>
      </div>
    </div>
  );
}

// ─── Sello / Logo ─────────────────────────────────────────────────────────────
function SelloCard() {
  return (
    <div className="res-sello-card">
      <div className="res-cat-stripe" style={{
        backgroundColor: '#e5e7eb',
        width: 'calc(100% + 40px)',
        marginLeft: -20, marginRight: -20,
        marginTop: -24, marginBottom: 20,
        borderRadius: '2px 2px 0 0',
      }} />
      <div className="res-sello-avatar">
        <a href='assets/images/LOGO-CQC.pdf' target='_blank' rel="noreferrer">
          <img src="assets/images/logo.jpg" alt="Ciudadesquecuidan" />
        </a>
      </div>
      <p style={{ marginTop: 12, fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        <a
          href='assets/images/LOGO-CQC.pdf'
          download="LOGO-CQC"
          target='_blank'
          rel="noreferrer"
          style={{ color: '#6f9b19', fontWeight: 600, textDecoration: 'underline' }}
        >
          Descargar sello
        </a>
      </p>
    </div>
  );
}


// ─── Componente principal ─────────────────────────────────────────────────────
export const Resultats = () => {
  const dispatch   = useDispatch();
  const navegacio  = useNavigate();
  const [t]        = useTranslation("generic");

  const { ui, auth, configApp, configUsuari } = useSelector(state => state);

  const fmt = (val) => val == null ? '' : (val % 1 === 0 ? String(val) : (val * 1).toFixed(2));

  const [data, setData] = useState({
    cat1: '', cat2: '', cat3: '', cat4: '', cat5: '',
    cat6: '', cat7: '', cat8: '', cat9: '', catTotal: '',
  });

  const getEvaluacio = () => {
    if (ui.resultatsEvaluacio != null) return ui.resultatsEvaluacio;
    if (ui.resultatsID != null && configApp.contingut && configApp.contingut[ui.resultatsID]) {
      return configApp.contingut[ui.resultatsID];
    }
    return null;
  };

  const ev = getEvaluacio();

  useEffect(() => {
    const evaluacio = getEvaluacio();
    if (evaluacio) {
      setData({
        cat1:     fmt(evaluacio.Resultado_TotalCat1),
        cat2:     fmt(evaluacio.Resultado_TotalCat2),
        cat3:     fmt(evaluacio.Resultado_TotalCat3),
        cat4:     fmt(evaluacio.Resultado_TotalCat4),
        cat5:     fmt(evaluacio.Resultado_TotalCat5),
        cat6:     fmt(evaluacio.Resultado_TotalCat6),
        cat7:     fmt(evaluacio.Resultado_TotalCat7),
        cat8:     fmt(evaluacio.Resultado_TotalCat8),
        cat9:     fmt(evaluacio.Resultado_TotalCat9),
        catTotal: fmt(evaluacio.ResultatGlobal),
      });
    }
  }, [ui]);

  if (!ev) return null;

  const municipio  = auth.admin === 1 ? ev.Nombre_Mun : (configUsuari.contingut?.nombre_Mun ?? '');
  const fechaFin   = moment(ev.DataFin_Evaluacion).format('DD/MM/YYYY');
  const scoreColor = getScoreColor(data.catTotal);

  const handleCat = (catNum) => {
    dispatch(addResultatsCategoria(auth.tokenJwt, ev.IdEvaluacion, catNum));
  };

  const cats = [
    { key: 'cat1', label: t('formulario.titleCat1'), num: 1 },
    { key: 'cat2', label: t('formulario.titleCat2'), num: 2 },
    { key: 'cat3', label: t('formulario.titleCat3'), num: 3 },
    { key: 'cat4', label: t('formulario.titleCat4'), num: 4 },
    { key: 'cat5', label: t('formulario.titleCat5'), num: 5 },
    { key: 'cat6', label: t('formulario.titleCat6'), num: 6 },
    { key: 'cat7', label: t('formulario.titleCat7'), num: 7 },
    { key: 'cat8', label: t('formulario.titleCat8'), num: 8 },
    { key: 'cat9', label: t('formulario.titleCat9'), num: 9 },
  ];

  return (
    <>
      {/* ── Encabezado ──────────────────────────────────────────────────── */}
      <div className="res-header">
        <div className="res-header-row">
          <div>
            <p className="uppercase font-medium text-sm tracking-[0.84px] after:bg-green-semilight after:absolute after:w-full after:h-2 relative after:left-0 inline-block after:bottom-0 after:-z-10">
              {municipio}
            </p>
            <h2 className="font-semibold mt-4 text-4xl leading-snug lg:text-5xl lg:leading-[62px]">
              Resultados {fechaFin}
            </h2>
          </div>

          <button
            className="res-back-btn"
            onClick={() => navegacio(-1)}
            onMouseEnter={e => (e.currentTarget.style.borderColor = '#6f9b19')}
            onMouseLeave={e => (e.currentTarget.style.borderColor = '#e5e7eb')}
          >
            ← Volver al historial
          </button>
        </div>

        <div className="res-pills">
          <span className="res-pill">📅 Finalizada: {fechaFin}</span>
          {data.catTotal && (
            <span
              className="res-pill-score"
              style={{
                backgroundColor: scoreColor + '18',
                color: scoreColor,
                border: `1px solid ${scoreColor}44`,
              }}
            >
              ⭐ Puntuación global: {data.catTotal}%
            </span>
          )}
        </div>
      </div>

      {/* ── Grid de categorías ──────────────────────────────────────────── */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-12'>
        {cats.map(({ key, label, num }) => (
          <CatCard
            key={key}
            label={label}
            value={data[key]}
            catColor={CAT_CONFIG[num - 1].color}
            catBg={CAT_CONFIG[num - 1].bg}
            onClick={() => handleCat(num)}
          />
        ))}
        <GlobalCard value={data.catTotal} />
        <div />
        <SelloCard />
      </div>

      {ui.resultatCat && <ResultatsCategoria />}
    </>
  );
};